// Client-side Better Auth. Exposes typed signIn / signUp / signOut / useSession
// hooks. Calls api.klemento.com/v1/auth/* (or VITE_API_BASE override). Cookies
// flow via credentials: "include" because app + api are on different
// subdomains.

import { createAuthClient } from "better-auth/react";

const API_BASE = (import.meta.env.VITE_API_BASE as string | undefined) ?? "https://api.klemento.com";

export const authClient = createAuthClient({
  baseURL: `${API_BASE}/v1/auth`,
  fetchOptions: {
    credentials: "include",
  },
});

export const { signIn, signUp, signOut, useSession } = authClient;
